import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateProductMutation } from "../graphql/mutations";
import type {
  CreateProductMutationType,
  CreateProductMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateProductMutation = (
  options?: MutationHookOptions<
    CreateProductMutationType,
    CreateProductMutationVariablesType
  >
) => {
  return useMutation<
    CreateProductMutationType,
    CreateProductMutationVariablesType
  >(CreateProductMutation, options);
};
